// This file is automatically generated by scripts/build-corejs3-shipped-proposals.mjs

export default new Set<string>([
  "esnext.suppressed-error.constructor",
  "esnext.array.from-async",
  "esnext.array.group",
  "esnext.array.group-to-map",
  "esnext.iterator.constructor",
  "esnext.iterator.drop",
  "esnext.iterator.every",
  "esnext.iterator.filter",
  "esnext.iterator.find",
  "esnext.iterator.flat-map",
  "esnext.iterator.for-each",
  "esnext.iterator.from",
  "esnext.iterator.map",
  "esnext.iterator.reduce",
  "esnext.iterator.some",
  "esnext.iterator.take",
  "esnext.iterator.to-array",
  "esnext.json.is-raw-json",
  "esnext.json.parse",
  "esnext.json.raw-json",
  "esnext.set.difference.v2",
  "esnext.set.intersection.v2",
  "esnext.set.is-disjoint-from.v2",
  "esnext.set.is-subset-of.v2",
  "esnext.set.is-superset-of.v2",
  "esnext.set.symmetric-difference.v2",
  "esnext.set.union.v2",
  "esnext.symbol.async-dispose",
  "esnext.symbol.dispose",
  "esnext.symbol.metadata",
]);
